import * as Yup from 'yup';

import { CreateLicenseField } from '@converge/data';

export const CreateLicenseFieldsSchema = Yup.object().shape({
  [CreateLicenseField.LicenseTypeUuid]: Yup.string().required(),
  [CreateLicenseField.LicenseRegionUuid]: Yup.string().required(),
  [CreateLicenseField.LicenseNumber]: Yup.string().required(),
  perpetual: Yup.boolean().default(false),
  [CreateLicenseField.LicenseExpirationDate]: Yup.date()
    .nullable()
    .when(['perpetual'], ([perpetual, licenseHolderUuid], schema) => {
      // If perpetual or using another broker's license (licenseHolderUuid is set), allow null
      if (perpetual === true) {
        return schema.nullable();
      }
      // Otherwise require a date
      return schema
        .required('This field is required')

        .min(new Date(), 'Expiration date must be in the future');
    }),
});
